"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var n = require('styled-components');
var faCircleExclamation = require('@fortawesome/free-solid-svg-icons/faCircleExclamation');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var n__default = /*#__PURE__*/_interopDefaultLegacy(n);

var a=n__default["default"](chunk2VCHSK65_js.d).attrs({forwardedAs:"p"})`
  ${r=>r.$variant==="helper"&&"color: var(--foreground-secondary);"}
  ${r=>r.$variant==="error"&&"color: var(--foreground-inline-error);"}
`,p=n__default["default"](chunkLXX3SSRV_js.b)`
  ${r=>r.$variant==="error"&&"color: var(--foreground-inline-error);"}
  padding-right: var(--spacing-small);
  font-size: var(--icon-size-regular);
`;var c=({variant:r="helper",icon:e,children:s,className:i,...m})=>jsxRuntime.jsxs(a,{$variant:r,className:i,...m,children:[(e!=null?e:r==="error")&&jsxRuntime.jsx(p,{icon:e!=null?e:faCircleExclamation.faCircleExclamation}),s]}),d=n__default["default"](c)``;

exports.a = d;
